/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/
import { createPlugin } from '@backstage/core-plugin-api';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
} from '@backstage/plugin-techdocs-react';
import { EditDocLinkAddon } from './EditDocLink';
import { BookmarkDocLinkAddon } from './BookmarkDocLink/BookmarkDocLink';
import { CustomTechDocStyleAddon } from './CustomTechDocStyle/CustomTechDocStyle';

export const bhTechdocsAddonsPlugin = createPlugin({
  id: 'bh-techdocs-addons',
});

export const EditDocLink = bhTechdocsAddonsPlugin.provide(
  createTechDocsAddonExtension({
    name: 'EditDocLink',
    location: TechDocsAddonLocations.Content,
    component: EditDocLinkAddon,
  }),
);

export const BookmarkDocLink = bhTechdocsAddonsPlugin.provide(
  createTechDocsAddonExtension({
    name: 'BookmarkDocLink',
    location: TechDocsAddonLocations.Content,
    component: BookmarkDocLinkAddon,
  }),
);

export const CustomTechDocStyle = bhTechdocsAddonsPlugin.provide(
  createTechDocsAddonExtension({
    name: 'CustomTechDocStyle',
    location: TechDocsAddonLocations.Content,
    component: CustomTechDocStyleAddon,
  }),
);